import styled from "styled-components";
import title from "@/assets/title2.png";
import { BlockContainer } from "../../layouts/style";
import naRed from "@/assets/na-red.png";
import naYellow from "@/assets/na-yellow.png";
import naContent from "@/assets/na-content.png";
import { useState } from "react";
import { message } from 'antd';
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import Tab4 from "./Tab4";
import Tab5 from "./Tab5";

const NewServerActivity = () => {
  const [selectTab, setSelectTab] = useState<string>("少年英雄");
  const list = [
    "少年英雄",
    "阶段解封",
    "登录即送",
    "充消返利",
    "新服宝藏",
    "帮会进驻",
    "版本庆典",
  ];

  const getContent = (item: string) => {
    if (selectTab !== item) return null;
    let content = <Tab1 />;
    switch (item) {
      case "少年英雄":
        content = <Tab1 />;
        break;
      case "阶段解封":
        content = <Tab2 />;
        break;
      case "登录即送":
        content = <Tab3 />;
        break;
      case "充消返利":
        content = <Tab4 />;
        break;
      case "新服宝藏":
        content = <Tab5 />;
        break;
      default:
        content = <div>待补充...</div>;
    }

    return (
      <div className="inner">
        <div className="scroll-bar"></div>
        {content}
      </div>
    );
  };

  const onChangeTab = (item: string) => {
    if (item === "帮会进驻") {
      // message.info('敬请期待');
      window.open('https://jx.xoyo.com/index1/detail.html?catid=3083&id=11363');
      return;
    }
    if (item === "版本庆典") {
      // message.info('敬请期待');
      window.open('https://jx.xoyo.com/p/zt/2024/03/11/ziliaopian/index.html');
      return;
    }
    setSelectTab(item);
  };
  return (
    <Container>
      <img src={title} alt="" className="title" />
      <div className="show">
        {list.map((item) => {
          const active = selectTab === item;
          return (
            <div key={item} className="t">
              <div className="t-name" onClick={() => onChangeTab(item)}>
                <img src={active ? naRed : naYellow} alt={item} />
                <div style={{ color: active ? "#ba4a2d" : "#cb7a21" }}>
                  {item}
                </div>
              </div>
              <div
                className={`t-content ${selectTab === item ? "active" : ""}`}
              >
                {getContent(item)}
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default NewServerActivity;

const Container = styled(BlockContainer)`
  height: 62rem;
  position: relative;
  .title {
    width: 27.56rem;
    height: 12.93rem;
    margin-top: 3.5rem;
  }
  .show {
    position: absolute;
    width: 100%;
    height: 53%;
    top: 58%;
    left: 1.8%;
    display: flex;
  }
  .t {
    height: 100%;
    display: flex;
    .t-name {
      height: 100%;
      position: relative;
      cursor: pointer;
      img {
        height: 100%;
      }
      div {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        color: #cb7a21;
        font-family: "思源宋体";
        display: flex;
        justify-content: center;
        align-items: center;
        writing-mode: vertical-rl;
        letter-spacing: 0.9rem;
        font-size: 1.5rem;
      }
    }
    .t-content {
      width: 0;
      transition: all 0.3s;
      overflow: hidden;
      & > img {
        width: 100%;
        height: 100%;
      }
      .inner {
        background: url(${naContent});
        background-size: 100% 100%;
        height: 100%;
        position: relative;
        .scroll-bar {
          position: absolute;
          width: 0.6rem;
          border-radius: 0.625rem;
          height: 91%;
          background: #cca369;
          right: 2.85%;
          top: 5%;
        }
        & > div:not(.scroll-bar) {
          margin: 1.5rem 1rem 1.5rem 2rem;
          overflow: auto;
          height: 92%;
          position: absolute;
          padding-right: 2rem;
          line-height: 2rem;
          font-size: 1rem;
          font-family: "思源宋体-normal";
          color: #686760;
        }
      }
    }
    .t-content.active {
      width: 34rem;
    }
    ::-webkit-scrollbar {
      width: 0.6rem;
      height: 0.6rem;
    }
    ::-webkit-scrollbar-thumb {
      width: 1rem;
      background-color: #fff;
      border-radius: 0.625rem;
      -webkit-border-radius: 0.625rem;
      -moz-border-radius: 0.625rem;
      -ms-border-radius: 0.625rem;
      -o-border-radius: 0.625rem;
    }
    ::-webkit-scrollbar-track {
      width: 1rem;
      background-color: rgba(0, 0, 0, 0);
      border-radius: 0.625rem;
      -webkit-border-radius: 0.625rem;
      -moz-border-radius: 0.625rem;
      -ms-border-radius: 0.625rem;
      -o-border-radius: 0.625rem;
    }
  }
`;
